<template>
  <div class="table">
    <div class="container">
      <div class="handle-box" style="padding-bottom: 10px">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('material.eightBitCode')" prop="eightBitCode">
                <el-input v-model="queryCondition.eightBitCode" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('material.eightBitCodeName')" prop="eightBitCodeName">
                <el-input v-model="queryCondition.eightBitCodeName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.plant.plantNo')" prop="plantNo">
                <el-input v-model="queryCondition.plantNo" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.plant.plantName')" prop="plantName">
                <el-input v-model="queryCondition.plantName" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('base.supplier.supplierCode')" prop="supplierCode">
                <el-input v-model="queryCondition.supplierCode" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.supplier.supplierName')" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="'包含禁用'" prop="showDisable">
                <el-checkbox v-model="queryCondition.showDisable" :disabled="isDisabled=='1'"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table">
        <el-table-column width="30" align="center">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmMaterialId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="eightBitCode" sortable :label="$t('material.eightBitCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable :label="$t('material.eightBitCodeName')"></el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="plantNo" sortable :label="$t('base.plant.plantNo')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantName" sortable :label="$t('base.plant.plantName')"></el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="supplierCode" sortable :label="$t('base.supplier.supplierCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" sortable :label="$t('base.supplier.supplierName')"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import commonFunction from "../../../utils/dataTableUtils"
import { materialService } from "../../../api/base-data/material";
import IcSelect from "@/components/common/icSelect";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import dataTableUtils from "../../../utils/dataTableUtils";
export default {
  name: 'materialPickPage',
  components: { IcSelect, SelDc },
  props: {
    isLto: {
      type: String,
    },
    tmSupplierId: {
      type: String,
    },
    mark: {
      type: String,
    }
  },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        isLto: null,
        tmSupplierId: null,
        eightBitCode: null,
        eightBitCodeName: null,
        plantNo: null,
        plantName: null,
        supplierCode: null,
        supplierName: null,
        pickupPoint: null,
        dcName: null,
        temperature: null,
        transportaionMethod: null,
        showDisable: null,
        scoped: true,
      },
      selectRows: [],
      radioVal: null,
      isDisabled:false
    }
  },
  created() {
    this.queryCondition.isLto = this.isLto;
    this.queryCondition.tmSupplierId = this.tmSupplierId;
    this.queryData(1);
  },
  watch: {
    tmSupplierId: {
      handler(newVal, oldVal) {
        this.tmSupplierId = newVal;
        this.queryCondition.tmSupplierId = newVal;
        this.queryData(1);
      },
      immediate: true,
    },
    mark: {
      handler(newVal, oldVal) {
        console.log("🚀 ~ file: materialInput.vue:54 ~ handler ~ newVal:", newVal)
        this.isDisabled=newVal
      },
      immediate: true,
    },
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      materialService.getMaterialDataV2(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows[0]);
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        isLto: null,
        eightBitCode: null,
        eightBitCodeName: null,
        plantNo: null,
        plantName: null,
        supplierCode: null,
        supplierName: null,
        pickupPoint: null,
        dcName: null,
        temperature: null,
        transportaionMethod: null,
        showDisable: null,
        tmSupplierId: this.tmSupplierId
      }
    },
    restQueryForm() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        isLto: null,
        eightBitCode: null,
        eightBitCodeName: null,
        plantNo: null,
        plantName: null,
        supplierCode: null,
        supplierName: null,
        pickupPoint: null,
        dcName: null,
        temperature: null,
        transportaionMethod: null,
        showDisable: null,
        tmSupplierId: this.tmSupplierId
      }
      this.queryData(1);
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    cancelSeleted: function () {
      this.radioVal = null;
      this.selectRows = null;
    }
  }, extends: dataTableUtils
}
</script>
<style scoped>
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
.el-select {
  width: 100%;
}
</style>
